import { render, staticRenderFns } from "./ComplaintsIndex.vue?vue&type=template&id=27debc10&"
import script from "./ComplaintsIndex.vue?vue&type=script&lang=js&"
export * from "./ComplaintsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports